// extracted by mini-css-extract-plugin
export default {"wrapper":"x2-z","play":"y2-z"};